import styled from 'styled-components';

const Separator = styled.div`
    width: 100%;
    border-bottom: 1px solid ${({ theme }) => theme.palette.border.light};
`;

export default Separator;
